<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext } from "svelte";
	import { max } from "d3-array";

	const { data, x, y, xScale, yGet, xRange, yRange, z, zGet } = getContext("LayerCake");

	export let label = (d) => $z(d);
	export let formatValue = (value) => value;
	export let labelPosition;


	/* --------------------------------------------
	 * Put the label on the highest value
	 */
	$: left = (values) => $xScale(max(values, $x)) / Math.max(...$xRange);
	$: top = (values) => {
		return $yGet(values[values.length - 1]) / Math.max(...$yRange);
		// return raw < 0.2 ? 0.2 : raw;
	};
</script>

{#each $data as group}
	<div
		class="label"
		class:right={labelPosition === 'right'}
		style="
				top:{(top(group.values) * 100)}%;
				color:{$zGet(group)};
				left:{left(group.values) * 100}%;
		"
	>
		<span class="label__main">{label(group)}</span>
		<span class="label__secondary">{formatValue(max(group.values, $y))}</span>
	</div>
{/each}

<style lang="scss">
	.label {
		position: absolute;
		// transform: translate(0, -100%) translateY(1px);
		font-size: 14px;
		line-height: 16px;
		max-width: 30px;
		transform: translate(20%, -50%) translateY(1px);

		&.right {
			text-align: right;
			right: 0;
			margin-right: 5px;
			margin-bottom: 5px;
			left: unset !important;
			max-width: 10000px;
			transform: translate(0, -100%) translateY(1px);

			@media (max-width: $breakpoint-mobile) {
				transform: translate(0, -100%) translateY(1px);
			}

			span {
				white-space: nowrap !important;
			}
		}

		span {
			white-space: normal;
			display: block;

			@media (max-width: $breakpoint-mobile) {
				white-space: normal;
			}
		}

		&__main {
			text-transform: uppercase;
			line-height: 1.2;
			font-weight: bold;
		}

		&__secondary {
			text-transform: uppercase;
		}
	}
</style>
